import yup from '~/libs/yup';

export const createSchema = yup.object({
  description: yup.string().required().label('Nome'),
  price_chd: yup.string().required().label('Taxa CHD'),
});

export const updateSchema = yup.object({
  description: yup.string().required().label('Nome'),
  price_chd: yup.string().required().label('Taxa CHD'),
});
